import React from 'react'
import { Badge } from '@/components/ui/badge'
import { useTranslation } from 'react-i18next'
import { namespace } from '@common-config/constants'

interface Props {
    isActive: boolean;
}

export default function ActiveSessionChip({ isActive }: Props) {
    const { t } = useTranslation(namespace);
    return (
        <Badge
            variant="secondary"
            style={{
                padding: '4px 8px',
                fontSize: '0.75rem',
                fontWeight: '500',
                borderRadius: '4px',
                backgroundColor: isActive 
                    ? 'var(--sessions-list-active-badge-bg)' 
                    : 'var(--sessions-list-version-bg)',
                color: isActive 
                    ? 'var(--sessions-list-active-badge-text)' 
                    : 'var(--sessions-list-version-text)',
            }}
        >
            {isActive ? t('chatbot.botDetail.filters.active') : t('chatbot.botDetail.filters.inactive')}
        </Badge>
    )
}
